import TextInput from "components/Input/Text";
import { registerInput } from "../index";

export default registerInput(TextInput);
